import * as React from 'react';
import {Col, Row} from "react-bootstrap";

const ThreeColumnRow = ({firstColumn, secondColumn, thirdColumn, main=false}) => {
    const marginBottom = main ? ('') : (' mb-4');

    return (
        <Row className={'justify-content-around align-items-center' + marginBottom}>
            <Col md={4} className={'text-md-left text-lg-left text-xl-left text-sm-center text-center mb-md-0 mb-lg-0 mb-xl-0 mb-sm-2 mb-2'}>{firstColumn}</Col>
            <Col md={4}>{main ? (<h1 className='text-center m-0'>{secondColumn}</h1>) : (<h2 className='text-center m-0'>{secondColumn}</h2>)}</Col>
            <Col md={4} className={'text-md-right text-lg-right text-xl-right text-sm-center text-center mt-md-0 mt-lg-0 mt-xl-0 mt-sm-2 mt-xs-2 mt-2'}>
                {thirdColumn}</Col>
        </Row>
    );
};

export default ThreeColumnRow;